import React from 'react';
import { Text, TextVariant } from '@naf/text';
import * as S from './FooterAddress.styles';

const FooterAddress = ({ address, postalAddress }: { address?: string; postalAddress?: string }) => {
  if (!address && !postalAddress) return null;

  return (
    <S.AddressInfo>
      <Text tag="p" variant={TextVariant.ArticleTextSubHeader}>
        Norges Automobil-Forbund
      </Text>
      <Text tag="p" variant={TextVariant.ArticleTextSubHeader}>
        {address && <span>{address}</span>}
        {postalAddress && <span>{`, ${postalAddress}`}</span>}
      </Text>
    </S.AddressInfo>
  );
};

export default FooterAddress;
